import { useUser } from 'contexts';
import { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getLastSaleReturnDaybook } from '../redux/actions/salesReturnInvoice';
import moment from 'moment';
import { getFinancialYears } from '../redux/actions/dashboard';

const useSalesReturnLastDaybook = () => {
   const [selectedDaybookId, setSelectedDaybookId] = useState(null);
   const { user } = useUser();
   const dispatch = useDispatch();
   const lastSaleReturnDaybook = useSelector((state) => state.salesReturnInvoice?.lastSaleDaybook);
   const financialYears = useSelector((state) => state?.dashboard?.financialYears);
   const financialYear1 = financialYears?.find((a) => a.financial_year === user?.financialYear);

   const getLastDaybook = useCallback(async () => {
      if (user && user?.loginhistory?.companyId && financialYear1?.financial_year) {
         // await dispatch(getFinancialYears({ companyId: user?.loginhistory?.companyId }));
         const financialYear = financialYears?.find((a) => a.financial_year === user?.financialYear);
         const fromDate = moment(financialYear?.fy_start_date, 'DD/MM/YYYY').format('YYYY-MM-DD');
         const toDate = moment(financialYear?.fy_end_date, 'DD/MM/YYYY').format('YYYY-MM-DD');

         const params = {
            companyId: user.loginhistory.companyId,
            fromDate,
            toDate,
            ...(selectedDaybookId && { daybookId: selectedDaybookId }),
         };
         await dispatch(getLastSaleReturnDaybook(params));
      }
   }, [dispatch, selectedDaybookId, user]);

   useEffect(() => {
      getLastDaybook();
   }, [getLastDaybook]);

   return { lastSaleReturnDaybook, setSelectedDaybookId };
};

export default useSalesReturnLastDaybook;
